import React from 'react';
import './Table.css';
// import * as Constants from 'Components/App/Constants.js';


export default function Table(props) {

	const x = props.x;

	const renderCount = React.useRef(0);
	const tableContent = React.useRef(null);
	const rows = React.useRef([]);
	const lastRow = React.useRef(0);
	const rawData = React.useRef([]);
	const [content, setContent] = React.useState('');
	const [resultSet, setResultSet] = React.useState([]);
	const [filters, setFilters] = React.useState({});

	const filterableColumns = (typeof props.filterableColumns === 'undefined') ? [] : props.filterableColumns;

	const addCloseButton = (typeof props.addcloseButton === 'undefined') ? false : props.addcloseButton;
	const addDeleteRow = (typeof props.addDeleteRow === 'undefined') ? false : props.addDeleteRow;
	const addEditRow = (typeof props.addEditRow === 'undefined') ? false : props.addEditRow;
	const deleteRowAllowed = (typeof props.deleteRowAllowed === 'undefined') ? false : props.deleteRowAllowed;
	const display = (typeof props.hideTable === 'undefined') ? '' : (props.hideTable) ? 'd-none' : '';
	const onAddColumn = (typeof props.onAddColumn === 'undefined') ? (key, value) => { return key } : props.onAddColumn;
	const onAddFooter = (typeof props.onAddFooter === 'undefined') ? () => { return null } : props.onAddFooter;
	const onAddHeader = (typeof props.onAddHeader === 'undefined') ? () => { return null } : props.onAddHeader;
	const onLoad = (typeof props.onLoad === 'undefined') ? () => { return null } : props.onLoad;
	const onRowClasses = (typeof props.onRowClasses === 'undefined') ? () => { return '' } : props.onRowClasses;
	const onRowEdit = (typeof props.onRowEdit === 'undefined') ? () => { } : props.onRowEdit;
	const onRowClick = (typeof props.onRowClick === 'undefined') ? onRowEdit : props.onRowClick;
	const onRowDelete = (typeof props.onRowDelete === 'undefined') ? (e, rowFields, rowId) => { rowDelete(rowId) } : props.onRowDelete;

	const table = {};
	init();

	React.useEffect(() => {
		if (renderCount.current < props.loadTable) {
			renderCount.current = props.loadTable;
			// console.log('load table' + props.id);
			load();
		}
	});

	React.useEffect(() => {
		if (rawData.current.length > 0) {
			makeTable(applyFilters(rawData.current));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filters]);

	function load() {
		const data = onLoad();
		if (data === null) {
			const url = 'Backend/webapp.php?module=' + props.module + '&task=' + props.listTask + ((typeof props.listParams === 'undefined') ? '' : props.listParams);
			x.was.axGet(url, (result) => {
				if (result.data['returncode'] === 1) {
					rawData.current = result.data['content'];
					setResultSet(result.data['content']);
					makeTable(applyFilters(result.data['content']));
				}
				else {
					x.wah.addHint('Error while reading table!', true);
				}
			});
		}
		else {
			rawData.current = data;
			setResultSet(data);
			makeTable(applyFilters(data));
		}
	}

	function applyFilters(data) {
		const activeFilters = filterableColumns.filter((key) => (filters[key] || '').trim() !== '');
		if (activeFilters.length === 0) {
			return data;
		}
		return data.filter((item) => activeFilters.every((key) => {
			const filterValue = filters[key].trim().toLowerCase();
			return String(item[key] ?? '').toLowerCase().indexOf(filterValue) !== -1;
		}));
	}

	function handleFilterChange(key, value) {
		setFilters((previous) => ({ ...previous, [key]: value }));
	}

	function rowClicked(e, rowFields, rowId) {
		e.preventDefault();
		if (e.target.getAttribute("deleterow") === '1') {
			if (deleteRowAllowed) {
				x.wau.yesNo("Wirklich löschen?",
					(result) => {
						console.log(result);
						if (result === 1) onRowDelete(e, rowFields, rowId);
						return;
					});
			}
			else {
				x.wah.addHint('Keine Berechtigung!');
			}
		}
		else if (e.target.getAttribute("editrow") === '1') {
			onRowEdit(e, rowFields, rowId);
		}
		else {
			onRowClick(e, rowFields, rowId);
		}
	}


	function rowDelete(rowId) {
		const url = 'Backend/webapp.php?module=' + props.module + '&task=' + props.deleteTask
		x.was.axPost(url, { "id": rowId }, (result) => {
			if (result.data['returncode'] === 1) {
				load();
			}
			else {
				x.wah.addHint('Fehler beim Löschen der Rubrik!', true);
			}
		})
	}

	function addFooter(content, columnClass) {
		table.rowFooterCount++
		if (typeof columnClass == 'undefined') {
			columnClass = '';
		}
		table.rowFooter.push(<span
			key={table.rowFooterCount}
			className={`column footer-column ${columnClass}  ${(table.rowFooterCount > 1) ? 'multicolumn' : ''} footer-column-${table.rowFooterCount}`}
		>
			{content}
		</span>);
	}

	function addHeader(content, columnClass) {
		table.rowHeaderCount++
		if (typeof columnClass == 'undefined') {
			columnClass = '';
		}
		table.rowHeader.push(
			<span
				key={table.rowHeaderCount}
				className={`column header-column ${columnClass}  ${(table.rowHeaderCount > 1) ? 'multicolumn' : ''} header-column-${table.rowHeaderCount}`}
			>
				{content}
			</span>);
	}

	function makeFilterRow() {
		if (filterableColumns.length === 0 || rawData.current.length === 0) {
			return null;
		}
		const cells = [];
		let columnCount = 1;
		Object.entries(rawData.current[0]).forEach(([key, value]) => {
			const column = onAddColumn(key, value);
			if (column === false) {
				return;
			}
			const isFilterable = filterableColumns.includes(key);
			cells.push(
				<span
					key={"filter-column-" + columnCount}
					className={`column filter-column ${(columnCount > 1) ? 'multicolumn' : ''} filter-column-${columnCount}`}
				>
					{isFilterable &&
						<span className="table-filter-input-wrap">
							<input
								type="text"
								className="table-filter-input"
								placeholder="Filtern…"
								value={filters[key] || ''}
								onChange={(e) => handleFilterChange(key, e.target.value)}
							/>
							<i
								className={`bi bi-x-circle table-filter-clear ${(filters[key] || '') === '' ? 'd-none' : ''}`}
								title="Filter zurücksetzen"
								onClick={() => handleFilterChange(key, '')}
							></i>
						</span>
					}
				</span>
			);
			columnCount++;
		});
		return cells;
	}

	function makeTable(data = resultSet) {
		init();
		const row = [];
		let columnTags = [];
		let columnCount = 1;
		let rowCount = 1;
		let rowClasses;

		onAddHeader(addHeader);
		onAddFooter(addFooter);

		data.forEach(
			function (item) {
				let rowId = null;
				columnCount = 1;

				// Add Columns
				columnTags = [];
				Object.entries(item).forEach(([key, value]) => {
					const column = onAddColumn(key, value);
					if (rowId === null) {
						rowId = value;
					}
					if (column !== false) {
						columnTags.push(
							<span
								key={"table-column-" + rowCount + "-" + columnCount}
								className={`column column-${columnCount} ${(columnCount > 1) ? 'multicolumn' : ''}`}
								title={(typeof column === 'object') ? '' : column}
							>
								{column}
							</span>
						);
						columnCount++;
					}
				});

				// Add Edit Column
				if (addEditRow) {
					columnTags.push(
						<span
							key={"table-column-" + rowCount + "-" + columnCount}
							className={`column column-${columnCount} ${(columnCount > 1) ? 'multicolumn' : ''}`}
						>
							<i
								className="bi bi-pencil"
								editrow="1"
							/>
						</span>);
					columnCount++;
				}

				// Add Delete Column
				if (addDeleteRow) {
					columnTags.push(
						<span
							key={"table-column-" + rowCount + "-" + columnCount}
							className={`column column-${columnCount} ${(columnCount > 1) ? 'multicolumn' : ''}`}
						>
							<i
								className="bi bi-trash3"
								deleterow="1"
							/>
						</span>);
				}

				// Add Row
				lastRow.current = rowCount;
				rowClasses = onRowClasses(item);
				rows.current[rowCount] = React.createRef();
				row.push(
					<div
						key={props.id + "-table-row-" + rowCount}
						id={"table-row-" + rowCount}
						ref={rows.current[rowCount]}
						onClick={(e) => rowClicked(e, item, rowId)}
						className={`table-row ${rowClasses}  `}
					>
						{columnTags}
					</div>
				)
				rowCount++;
			}
		)

		const headerTag = makeHeaderTag((typeof props.customFilterRow !== 'undefined') ? props.customFilterRow : makeFilterRow());
		const footerTag = makeFooterTag();
		const content =
			<div id={props.id} key="table" className={`table-basis ${props.classes} ${display}`} >
				{headerTag}
				<div key="table-content" className='table-content' ref={tableContent}>
					{row}
				</div>
				{footerTag}
			</div>
		setContent(content);
	}

	function makeHeaderTag(filterRow) {
		if (table.rowHeader.length > 0) {
			if (addCloseButton) addHeader(<i className="bi bi-x-lg table-icon" onClick={e => x.wab[props.id].hide()} />, 'table-close-button');
			if (addEditRow) addHeader(<i className="bi bi-pencil" />);
			if (addDeleteRow) addHeader(<i className="bi bi-trash3" />);
			return (
				<div key="table-header" className='table-header'>
					<div key="table-header-row"
						className={` table-header-row
										${(typeof props.headerClass == 'undefined')
								? ''
								: props.HeaderClass} ${(table.rowHeaderCount < 2) ? 'table-header-center' : 'table-header-left'} `
						}>
						{table.rowHeader}
					</div>
					{filterRow &&
						<div key="table-filter-row" className="table-filter-row">
							{filterRow}
						</div>
					}
				</div>
			)
		}
		else {
			return null;
		}
	}

	function makeFooterTag() {
		if (table.rowFooter.length > 0) {
			return (
				<div key="table-footer"
					className={` table-footer 
							${(typeof props.footerClass == 'undefined')
							? ''
							: props.footerClass}  `
					}>
					{table.rowFooter}
				</div>
			)
		}
		else {
			return null;
		}
	}

	function init() {
		table.rowHeader = [];
		table.rowFooter = [];
		table.rowHeaderCount = 0;
		table.rowFooterCount = 0;
	}

	return (
		<>
			{content}
		</>
	);

}
